import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { TENANT_MODULE_NAMESPACE, TENANT_GET_BLOCK_TENANT } from '../../../store/tenant';

import { OWNER_MODULE_NAMESPACE, OWNER_GET_BLOCK_OWNER } from '../../../store/owner';
import { CrudStatus } from '../../../common/enums';
import { PROFILE_MODULE_NAMESPACE, PROFILE_INIT_MEMBER_SELECTION, PROFILE_ACTION, PROFILE_DELETE_MEMBER } from '../../../store/profile/profile-types.store';
import { TranslateResult } from 'vue-i18n';
import { Uris } from '../../../common/constants';
import { BLOCK_MODULE_NAMESPACE, BLOCK_SET_LOADER_STATE, BLOCK_LOADERS } from '../../../store/block';

const TenantStore = namespace(TENANT_MODULE_NAMESPACE)
const OwnerStore = namespace(OWNER_MODULE_NAMESPACE)
const ProfileStore= namespace(PROFILE_MODULE_NAMESPACE)
const BlockStore= namespace(BLOCK_MODULE_NAMESPACE)

@Component({
  components: {
    'base-avatar': async () => import('@/components/avatar/Avatar.vue'),
    'user-profile-enhanced-widget': async () => import('@/components/user-profile-enhanced-widget/UserProfileEnhancedWidget.vue'),
    'user-profile-widget': async () => import('@/components/user-profile-widget/UserProfileWidget.vue'),
    'block-infos-loader': async () => import('../loaders/block-infos-loader/BlockInfosLoader.vue'),
  }
})
class BlockApartmentsTenants extends Vue {

  _cleatTimeout: any;
  dtCenter: { lat: number, lng: number };
  dtMarkerPosition: { lat: number | null, lng: number | null };
  dtStyle: any | null;
  dtMessageErrorModel: boolean
  dtError: any
  dtIsLoading: boolean

  constructor() {
    super();
    this.dtStyle = null;
    this.dtCenter = {
      lat: 48.864716, lng: 2.349014
    }
    this.dtMarkerPosition = null;
    this.dtMessageErrorModel= false
    this.dtError= null
    this.dtIsLoading= false
  }
  @TenantStore.Getter currentTenant: any;
  @OwnerStore.Getter currentOwner: any;
  @BlockStore.Getter loaders: Map<string,boolean>
  @ProfileStore.Getter profileCrudActionStatus: CrudStatus

  @TenantStore.Action(TENANT_GET_BLOCK_TENANT)
  storeGetTenantById: (payload: { blockId: string, tenantId: string }) => Promise<any>
  @OwnerStore.Action(OWNER_GET_BLOCK_OWNER)
  storeGetOwnerById: (payload: { blockId: string, ownerId: string }) => Promise<any>
  @ProfileStore.Mutation(PROFILE_INIT_MEMBER_SELECTION)
  storeInitMemberSelection: () => void
  @ProfileStore.Mutation(PROFILE_ACTION)
  storeSetProfileAction: (action: CrudStatus) => void
  @ProfileStore.Action(PROFILE_DELETE_MEMBER)
  storeDeleteMember: () => Promise<any>
  @BlockStore.Mutation(BLOCK_SET_LOADER_STATE)
  storeSetBlockLoaderState: (payload?: { key: string, value: boolean }) => void


  get lblSetting () {
    return {
      ...require('@/locales/block').default,
      ...require('@/locales/apartment').default,
      ...require('@/locales/generic-labels').default,
      ...require('@/locales/profile').default
    }
  }
  get mapConfig() {
    return require('@/assets/json-resources/mapbox-config.json')
  }
  get isTenantPage(): boolean {
    return this.$route.path.indexOf('tenant') > -1
  }
  get entity() {
    return Object.assign({
      tenants: [],
      owners: [],
      caretakers: [],
      address: {},
      apartments: [],
    }, this[this.isTenantPage ? 'currentTenant' : 'currentOwner'])
  }
  get addressLine1(): string {
    return this.entity.address.line1
  }
  get addressLine2(): string {
    return this.entity.address.line2
  }
  get zipCode(): string {
    return this.entity.address.zip_code
  }
  get city(): string {
    return this.entity.address.city; //Fucking dont know the response has been changed for long time
  }
  get digicode(): string {
    console.log('current entity=',this.entity)
    return this.entity.digicode;
  }
  get numApartment(): string {
    return !(this.entity && this.entity.number_apartments) ? "" :
                    typeof this.entity.number_apartments === "object" ?
                    this.entity.number_apartments.join(',') : this.entity.number_apartments.toString()
  }

  get coCaretakers() {
    return (this.entity.caretakers || []).map(x => this.mapToResource(x).next().value);

  }

  get isOpenDeleteMessage(): boolean {
    return this.profileCrudActionStatus === CrudStatus.Delete
  }

  get coProfileDelectionMessage(): TranslateResult {
    return this.$t(this.lblSetting.profileDeleteMessage,{ fullname: `${this.userContact.firstname} ${this.userContact.lastname}`.trim() })
  }


  *mapToResource(x) {
    const avatar = `${(x.firstname || '').substring(0, 1)} ${(x.lastname || '').substring(0, 1)}`;
    yield {
      firstname: x.firstname,
      lastname: x.lastname,
      email: x.email,
      landline: x.landline,
      cellphone: x.cellphone,
      id: x.id,
      avatar: avatar.trim().replace(' ', '/')
    }
  }
  getTenantId(): number {
    return this.entity.id;
  }
  get hasCaretaker(): string {
    return this.entity.caretakers.length > 0 ? 'oui' : 'non';
  }
  get tenant() {
    return this.entity[this.isTenantPage ? 'tenants' : 'owners'][0] || {}
  }
  get userContact(){
    const contact = this.entity[this.isTenantPage ? 'tenants' : 'owners'][0] || {}
    console.log("current user contact",contact,this.entity)
    return {
      ...contact,
      address: this.entity.address
    }
  }
  get coLoader(): boolean {
    return this.loaders.get(BLOCK_LOADERS.INFOS)
  }
  initMapContainer() {
    let intervalMapTracer: any;
    let isCleared: boolean;
    this.$nextTick(() => {
      isCleared = false;
      if (!isCleared) {
        clearInterval(intervalMapTracer);
        let mainContainer = document.getElementsByClassName('main-container')[0];
        if (mainContainer) {
          let width: number = ((mainContainer.clientWidth - 500) / 4);
          this.dtStyle = {
            width: width + 'px !important',
            'min-width': width + 'px !important',
            'max-width': width + 'px !important',
            height: width + 'px  !important',
            'min-height': width + 'px  !important',
            'max-height': width + 'px  !important'
          }

        }
      }

    })
  }
  mounted() {
    this.initMapContainer()
    this.getResource(this.$route.params.id, this.$route.params.cid);
    this.$watch('$route.params', ({ id, cid }) => {
      this.getResource(id, cid);
    })
    if (this.$route.path.indexOf('/tenant/') > -1) {
      window.onresize = () => this.initMapContainer();
    }
  }
  getResource(id: string, cid: string) {
    this.storeSetBlockLoaderState({ key: BLOCK_LOADERS.INFOS, value: true })
    if (this.isTenantPage) {
      this.storeGetTenantById({ blockId: id, tenantId: cid })
        .then((res: { address: any }) => {
          this.dtCenter = { lat: Number(res.address.lat), lng: Number(res.address.lng) }
          this.dtMarkerPosition = { lat: Number(res.address.lat), lng: Number(res.address.lng) }
        })
        .finally(()=> this.storeSetBlockLoaderState({ key: BLOCK_LOADERS.INFOS, value: false }))
    }
    else {
      this.storeGetOwnerById({ blockId: id, ownerId: cid })
        .then(res => {
        })
        .finally(()=> this.storeSetBlockLoaderState({ key: BLOCK_LOADERS.INFOS, value: false }) )
    }

  }
  renderMap({ lat, lng }) {
  }

  handleGetTenantById(blockId: string, tenantId: string) {
    clearTimeout(this._cleatTimeout)
    this._cleatTimeout = setTimeout(() => {
      this.storeGetTenantById({ blockId, tenantId })
    }, 300);
  }

  handleCloseErrorModal(){
    this.dtMessageErrorModel= false
    this.dtError= null
  }

  handleDeleteCancel(){
    this.storeInitMemberSelection()
    this.storeSetProfileAction(CrudStatus.NoAction)
  }

  handleDeleteOK(){
      this.dtIsLoading= true
      this.storeDeleteMember()
      .then(()=>{
        this.storeInitMemberSelection()
        this.$router.replace(Uris.BlockIdContacts.replace(':id',this.$route.params.id))
      })
      .catch(err=>{
        this.dtMessageErrorModel= true
        this.dtError= err
      })
      .finally(()=> this.dtIsLoading= false )
  }
}

export default BlockApartmentsTenants;



// WEBPACK FOOTER //
// ./src/containers/block/block-tenants-detail/index.ts